import { EventDate } from 'api/multistageTournament/getEventDates'

export const getDateFromDateSlug = (dateSlug: string, dates: EventDate[]) => {
  return dates.find((item: EventDate) => {
    return item.slug === dateSlug
  })
}
